import z from 'zod';
import { quantitySchema } from '../../validation';
import { vehicleQuantityAndTypeSchema } from '../../common';

export const orgFleetSchema = z.object({
  /** the actual total number of vehicles that the org has.
   *
   * This will be incremented every time a new vehicle is added to the system which belongs to this org.
   */
  total: quantitySchema,

  /** the actual total number of vehicles by type that the org has.
   *
   * if empty then he has nothing.
   */
  types: z.array(vehicleQuantityAndTypeSchema),
});
